var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficebuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1999 3.7001C3.1999 2.81644 3.91625 2.1001 4.7999 2.1001H11.1999C12.0836 2.1001 12.7999 2.81644 12.7999 3.7001V13.3001C13.2417 13.3001 13.5999 13.6583 13.5999 14.1001C13.5999 14.5419 13.2417 14.9001 12.7999 14.9001H10.5999C10.0476 14.9001 9.5999 14.4524 9.5999 13.9001V12.5001C9.5999 12.0583 9.24173 11.7001 8.7999 11.7001H7.1999C6.75807 11.7001 6.3999 12.0583 6.3999 12.5001V13.9001C6.3999 14.4524 5.95219 14.9001 5.3999 14.9001H3.1999C2.75807 14.9001 2.3999 14.5419 2.3999 14.1001C2.3999 13.6583 2.75807 13.3001 3.1999 13.3001V3.7001ZM5.5999 4.5001H7.1999V6.1001H5.5999V4.5001ZM7.1999 7.7001H5.5999V9.3001H7.1999V7.7001ZM8.7999 4.5001H10.3999V6.1001H8.7999V4.5001ZM10.3999 7.7001H8.7999V9.3001H10.3999V7.7001Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficebuilding);
export default __webpack_public_path__ + "static/media/Office building.4dacd3664f338e9ad61324588afa4e28.svg";
export { ForwardRef as ReactComponent };